<template>
   <div class="container-fluid">
      <div class="card">
         <div class="card-body">

            <!-- Security Section -->
            <div class="settings-section">
               <h6 class="section-title">
                  <i class="fa-solid fa-shield-halved me-2"></i>Security
               </h6>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Block Unsafe and Dangerous Websites</span>
                     <span class="setting-desc">Automatically blocks dangerous websites.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('enable_block_unsafe_site')"
                        :checked="settings['enable_block_unsafe_site']"
                        :disabled="action_cooldowns['enable_block_unsafe_site']">
                  </div>
               </div>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Block HTTP Websites</span>
                     <span class="setting-desc">Only HTTPS websites are allowed.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('enable_block_http')"
                        :checked="settings['enable_block_http']"
                        :disabled="action_cooldowns['enable_block_http']">
                  </div>
               </div>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Phishing Protection</span>
                     <span class="setting-desc">Only allow allowlisted websites for login.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('enable_phishing_protection')"
                        :checked="settings['enable_phishing_protection']"
                        :disabled="action_cooldowns['enable_phishing_protection']">
                  </div>
               </div>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Enforce Safe Search</span>
                     <span class="setting-desc">Enforce safe search on Google, Yahoo, DuckDuckGo, and Bing.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('enable_safe_search')"
                        :checked="settings['enable_safe_search']"
                        :disabled="action_cooldowns['enable_safe_search']">
                  </div>
               </div>

               <div class="setting-row" style="flex-direction: column; align-items: stretch;">
                  <div class="d-flex justify-content-between align-items-center w-100">
                     <div class="setting-info">
                        <span class="setting-label">Block Downloads</span>
                        <span class="setting-desc">Block download of dangerous files (e.g. .bat, .exe).</span>
                     </div>
                     <div class="form-check form-switch">
                        <input
                           class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                           type="checkbox"
                           @click="ChangeSettings('block_download')"
                           :checked="settings['block_download']"
                           :disabled="action_cooldowns['block_download']">
                     </div>
                  </div>
                  <div class="mt-2">
                     <router-link to="/account-block-list?tab=extensions" style="color: #00a0c1; font-size: 13px;">
                        Manage blocked file extensions
                        <i class="fa-solid fa-arrow-right-long ms-1"></i>
                     </router-link>
                  </div>
               </div>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Block All Websites</span>
                     <span class="setting-desc">Block all websites except allowlisted websites.</span>
                  </div>
                   <div class="form-check form-switch">
                      <input
                         class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                         type="checkbox"
                         @click="handleBlockAllWebsitesClick($event)"
                         :checked="settings['block_all_websites'] == 1 || settings['block_all_websites'] === true"
                         :disabled="action_cooldowns['block_all_websites']">
                   </div>
               </div>
            </div>

            <!-- Data Loss Protection Section -->
            <div class="settings-section">
               <h6 class="section-title">
                  <i class="fa-solid fa-lock me-2"></i>Data Loss Protection
               </h6>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Data Loss Prevention (DLP)</span>
                     <span class="setting-desc">Blocks all uploads to prevent confidential data from leaving the network.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('enable_block_dlp')"
                        :checked="settings['enable_block_dlp']"
                        :disabled="action_cooldowns['enable_block_dlp']">
                  </div>
               </div>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Disable File Sharing</span>
                     <span class="setting-desc">Disables file sharing capabilities.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('disable_file_sharing')"
                        :checked="settings['disable_file_sharing']"
                        :disabled="action_cooldowns['disable_file_sharing']">
                  </div>
               </div>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Block Upload to All Websites</span>
                     <span class="setting-desc">Blocks all upload activity.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('block_upload_all_websites')"
                        :checked="settings['block_upload_all_websites']"
                        :disabled="action_cooldowns['block_upload_all_websites']">
                  </div>
               </div>

               <!-- Common Cloud Storage sub-section -->
               <div class="setting-row" style="flex-direction: column; align-items: stretch;">
                  <span class="setting-label mb-2">Common Cloud Storage</span>
                  <div class="table-responsive" style="max-width: 500px;">
                     <table class="table table-sm align-middle mb-0">
                        <thead class="table-light">
                           <tr>
                              <th scope="col">Website</th>
                              <th scope="col" class="text-center">Allow Upload</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="(storage, index) in common_cloud_storage" :key="index">
                              <td>{{ storage.website }}</td>
                              <td class="text-center">
                                 <div class="form-check form-switch d-flex justify-content-center mb-0">
                                    <input
                                       class="form-check-input form-custom-check-input form-custom-check-size border-success hand-cursor"
                                       type="checkbox"
                                       @click="AddOrRemoveStorageFromAccount(index)"
                                       :checked="common_cloud_storage[index].ww_id.Valid == true && common_cloud_storage[index].ww_id.Int64 > 0 && common_cloud_storage[index].allow_upload.Valid && common_cloud_storage[index].allow_upload.Bool">
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>

            <!-- Logging & Notifications Section -->
            <div class="settings-section">
               <h6 class="section-title">
                  <i class="fa-solid fa-bell me-2"></i>Logging &amp; Notifications
               </h6>

               <div class="setting-row">
                  <div class="setting-info">
                     <span class="setting-label">Disable Logging</span>
                     <span class="setting-desc">Only blocked pages or password pages are logged for privacy.</span>
                  </div>
                  <div class="form-check form-switch">
                     <input
                        class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                        type="checkbox"
                        @click="ChangeSettings('disable_logging')"
                        :checked="settings['disable_logging']"
                        :disabled="action_cooldowns['disable_logging']">
                  </div>
               </div>

               <div class="setting-row" style="flex-direction: column; align-items: stretch;">
                  <div class="d-flex justify-content-between align-items-center w-100">
                     <div class="setting-info">
                        <span class="setting-label">Email Alerts Protection</span>
                        <span class="setting-desc">Send email alerts for unsafe URLs.</span>
                     </div>
                     <div class="form-check form-switch">
                        <input
                           class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                           type="checkbox"
                           @click="ChangeSettings('enable_email_alerts')"
                           :checked="settings['enable_email_alerts']"
                           :disabled="action_cooldowns['enable_email_alerts']">
                     </div>
                  </div>
                  <div v-if="settings['enable_email_alerts']" class="mt-3" style="max-width: 400px;">
                     <div class="input-group">
                        <input v-model="settings['alert_email']" type="text"
                           class="form-control form-control-sm" placeholder="Enter alert email..."
                           style="border-radius: 8px 0 0 8px;">
                        <button @click="ChangeSettings('alert_email')" type="button"
                           class="btn btn-sm btn-outline-secondary"
                           style="border-radius: 0 8px 8px 0;"
                           :disabled="action_cooldowns['alert_email']">Save</button>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Access Control Section -->
            <div class="settings-section">
               <h6 class="section-title">
                  <i class="fa-solid fa-sliders me-2"></i>Access Control
               </h6>

               <div class="setting-row" style="flex-direction: column; align-items: stretch;">
                  <div class="d-flex justify-content-between align-items-start w-100">
                     <div class="setting-info">
                        <span class="setting-label">Government TLDs</span>
                        <span class="setting-desc">Control access to domains on the master government TLD list.</span>
                     </div>
                  </div>
                  <div class="mt-2">
                     <div class="btn-group" role="group">
                        <button type="button"
                           class="btn btn-outline-left btn-sm rounded-start-pill btn-check-left hand-cursor"
                           @click="ChangeSettings2('government_tld_setting', 1)"
                           :class="{ active: settings['government_tld_setting'] == 1 }"
                           :disabled="action_cooldowns['government_tld_setting']">Allow</button>
                        <button type="button" class="btn btn-outline-center btn-sm btn-check-center hand-cursor"
                           @click="ChangeSettings2('government_tld_setting', 0)"
                           :class="{ active: settings['government_tld_setting'] == 0 }"
                           :disabled="action_cooldowns['government_tld_setting']">Off</button>
                        <button type="button"
                           class="btn btn-outline-right btn-sm rounded-end-pill btn-check-right hand-cursor"
                           @click="ChangeSettings2('government_tld_setting', 2)"
                           :class="{ active: settings['government_tld_setting'] == 2 }"
                           :disabled="action_cooldowns['government_tld_setting']">Block</button>
                     </div>
                     <div v-if="settings['government_tld_setting'] == 0" class="mt-2">
                        <router-link to="/account-government-tlds" style="color: #00a0c1; font-size: 13px;">
                           Manage individual TLD list
                           <i class="fa-solid fa-arrow-right-long ms-1"></i>
                        </router-link>
                     </div>
                  </div>
               </div>

               <div class="setting-row" style="flex-direction: column; align-items: stretch;">
                  <div class="d-flex justify-content-between align-items-start w-100">
                     <div class="setting-info">
                        <span class="setting-label">AI Categories</span>
                        <span class="setting-desc">Control access to AI platforms and tools (e.g., ChatGPT, Claude, Gemini).</span>
                     </div>
                  </div>
                  <div class="mt-2">
                     <div class="btn-group" role="group">
                        <button type="button"
                           class="btn btn-outline-left btn-sm rounded-start-pill btn-check-left hand-cursor"
                           @click="ChangeSettings2('ai_category_setting', 1)"
                           :class="{ active: settings['ai_category_setting'] == 1 }"
                           :disabled="action_cooldowns['ai_category_setting']">Allow</button>
                        <button type="button" class="btn btn-outline-center btn-sm btn-check-center hand-cursor"
                           @click="ChangeSettings2('ai_category_setting', 0)"
                           :class="{ active: settings['ai_category_setting'] == 0 }"
                           :disabled="action_cooldowns['ai_category_setting']">Off</button>
                        <button type="button"
                           class="btn btn-outline-right btn-sm rounded-end-pill btn-check-right hand-cursor"
                           @click="ChangeSettings2('ai_category_setting', 2)"
                           :class="{ active: settings['ai_category_setting'] == 2 }"
                           :disabled="action_cooldowns['ai_category_setting']">Block</button>
                     </div>
                     <div v-if="settings['ai_category_setting'] == 0" class="mt-2">
                        <router-link to="/account-ai-categories" style="color: #00a0c1; font-size: 13px;">
                           Manage individual AI categories
                           <i class="fa-solid fa-arrow-right-long ms-1"></i>
                        </router-link>
                     </div>
                  </div>
               </div>

               <div class="setting-row" style="flex-direction: column; align-items: stretch;">
                  <div class="d-flex justify-content-between align-items-start w-100">
                     <div class="setting-info">
                        <span class="setting-label">OAuth Websites</span>
                        <span class="setting-desc">Control access to OAuth authentication websites.</span>
                     </div>
                  </div>
                  <div class="mt-2">
                     <div class="btn-group" role="group">
                        <button type="button"
                           class="btn btn-outline-left btn-sm rounded-start-pill btn-check-left hand-cursor"
                           @click="ChangeSettings2('oauth_websites', 1)"
                           :class="{ active: settings['oauth_websites'] == 1 }"
                           :disabled="action_cooldowns['oauth_websites']">Allow</button>
                        <button type="button" class="btn btn-outline-center btn-sm btn-check-center hand-cursor"
                           @click="ChangeSettings2('oauth_websites', 0)"
                           :class="{ active: settings['oauth_websites'] == 0 }"
                           :disabled="action_cooldowns['oauth_websites']">Off</button>
                        <button type="button"
                           class="btn btn-outline-right btn-sm rounded-end-pill btn-check-right hand-cursor"
                           @click="ChangeSettings2('oauth_websites', 2)"
                           :class="{ active: settings['oauth_websites'] == 2 }"
                           :disabled="action_cooldowns['oauth_websites']">Block</button>
                     </div>
                  </div>
               </div>
            </div>

         </div>
      </div>

      <!-- Block All Websites Warning Confirmation Modal -->
      <div class="modal-backdrop-custom" v-if="showBlockAllWarningModal" @click.self="cancelEnableBlockAllWebsites">
         <div class="modal-content-custom">
            <button @click="cancelEnableBlockAllWebsites" class="close-button-custom">&times;</button>
            <h5 class="modal-title-custom text-danger">
               <i class="fa-solid fa-triangle-exclamation me-2 text-warning"></i>
               Enable "Block All Websites"?
            </h5>
            <hr>
            <div class="modal-body-custom">
               <div class="alert alert-warning py-2 px-3 mb-3" style="font-size: 13px; border-radius: 8px;">
                  <i class="fa-solid fa-circle-exclamation me-1"></i>
                  <strong>Strict Zero-Trust Policy:</strong> Enabling this setting will block all web traffic across your organisation's managed endpoints.
               </div>
               <p class="mb-2">
                  Only websites explicitly configured in your <strong>Organisation Allow List</strong>, Vertex cybersecurity infrastructure services, and local development hosts (<code>localhost</code> / <code>127.0.0.1</code>) will remain accessible.
               </p>
               <p class="mb-0 text-muted" style="font-size: 13px;">
                  Please verify your allowed domains in the <router-link to="/account-allow-list" class="text-primary fw-bold">Allow List</router-link> before enabling this policy.
               </p>
            </div>
            <div class="modal-footer-custom">
               <button type="button" class="btn btn-sm btn-modal-cancel px-3" @click="cancelEnableBlockAllWebsites">
                  Cancel
               </button>
               <button type="button" class="btn btn-sm btn-danger px-3 text-light" style="border-radius: 8px;"
                  @click="confirmEnableBlockAllWebsites">
                  <i class="fa-solid fa-shield me-1"></i> I Understand, Enable Policy
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import * as bootstrap from 'bootstrap';
import { extractErrorMessage } from '@/plugins/helper.js';

export default {
   data() {
      return {
         headers: [
            { text: "Domain", value: "domain" },
            { text: "Action", value: "action" },
         ],
         settings: [],
         common_cloud_storage: [],
         action_cooldowns: {},
         showBlockAllWarningModal: false,
      };
   },

   mounted() {
      this.init();
   },

   methods: {
      init() {
         this.getAccountSettings()
      },

      setCooldown(key) {
         if (typeof this.$set === 'function') {
            this.$set(this.action_cooldowns, key, true);
            setTimeout(() => {
               this.$delete(this.action_cooldowns, key);
            }, 1250);
         } else {
            this.action_cooldowns[key] = true;
            setTimeout(() => {
               delete this.action_cooldowns[key];
            }, 1250);
         }
      },

      async getAccountSettings() {
         this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-settings")
            .then((response) => {
               this.settings = response.data.settings
               this.$nextTick(() => {
                  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
                     bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl)
                  })
               });
            })
            .catch((error) => {
               if(error.response) this.$toast.error(extractErrorMessage(error, "Failed to load account settings."))
            })

         this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-common-cloud-storage")
            .then((response) => {
               this.common_cloud_storage = response.data.common_cloud_storage
            })
            .catch(() => {})
      },

      async AddOrRemoveStorageFromAccount(index) {
         try {
            let payload = {}
            let resp = null

            if (this.common_cloud_storage[index].ww_id.Int64 == 0) {
               payload = {
                  "domain": this.common_cloud_storage[index].website,
                  "id": this.common_cloud_storage[index].ww_id.Int64,
               }
               resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/add-storage-to-account", payload)

               if (resp.data.success != null && resp.data.success == false) {
                  this.$toast.error(resp.data.message)
               } else {
                  this.$toast.success(resp.data.message + " Please note: It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.")
                  this.common_cloud_storage[index].ww_id.Int64 = resp.data.allowed_website.id
               }

            } else {
               let allowUpload = this.common_cloud_storage[index].allow_upload.Bool;
               payload = {
                  "domain": this.common_cloud_storage[index].website,
                  "id": this.common_cloud_storage[index].ww_id.Int64,
                  "allow_upload": allowUpload ? 0 : 1
               }

               resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-storage/" + this.common_cloud_storage[index].ww_id.Int64, payload)
               this.common_cloud_storage[index].ww_id.Int64 = 0

               if (resp.data.success != null && resp.data.success == false) {
                  this.$toast.error(resp.data.message)
               } else {
                  this.$toast.success(resp.data.message + " Please note: It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.")
               }
            }
            this.getAccountSettings()
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to update storage settings."))
         }
      },

      async ChangeSettings(column_name) {
         if (this.action_cooldowns[column_name]) return;
         this.setCooldown(column_name);

         const columnNameCurrentValue = this.settings[column_name];

         if (column_name == "alert_email") {
            this.settings[column_name] = columnNameCurrentValue
         } else {
            this.settings[column_name] = columnNameCurrentValue == 0 ? 1 : 0;
         }

         let payload = {
            "settings_column": column_name,
            "settings_value": this.settings[column_name]
         }

         try {
            const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-setting", payload)

            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message + " Please note: It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.")
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to update setting."))
         }
      },

      async ChangeSettings2(column_name, value) {
         if (this.action_cooldowns[column_name]) return;

         const columnNameCurrentValue = this.settings[column_name];
         if (columnNameCurrentValue == value) return;

         this.setCooldown(column_name);
         this.settings[column_name] = value;

         let payload = {
            "settings_column": column_name,
            "settings_value": this.settings[column_name]
         }

         try {
            const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-setting", payload)

            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message + " Please note: It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.")
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to update setting."))
         }
      },

      handleBlockAllWebsitesClick(event) {
         if (this.action_cooldowns['block_all_websites']) {
            if (event) event.preventDefault();
            return;
         }

         const isCurrentlyEnabled = this.settings['block_all_websites'] == 1 || this.settings['block_all_websites'] === true;

         if (!isCurrentlyEnabled) {
            // Intercept turning ON: prevent immediate toggle and show warning modal
            if (event) event.preventDefault();
            this.showBlockAllWarningModal = true;
         } else {
            // Turning OFF: directly disable without modal
            this.ChangeSettings('block_all_websites');
         }
      },

      confirmEnableBlockAllWebsites() {
         this.showBlockAllWarningModal = false;
         this.ChangeSettings('block_all_websites');
      },

      cancelEnableBlockAllWebsites() {
         this.showBlockAllWarningModal = false;
      }
   }
}
</script>

<style scoped>
.card {
   border: none;
}

/* Modal */
.modal-backdrop-custom {
   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
   background-color: rgba(0,0,0,0.5); display: flex;
   justify-content: center; align-items: center; z-index: 1050;
}
.modal-content-custom {
   position: relative; background: #fff; padding: 2rem;
   border-radius: 14px; width: 100%; max-width: 540px;
   box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}
.modal-title-custom { font-weight: 700; font-size: 1.1rem; color: #435666; margin-bottom: 0; }
.modal-content-custom hr { margin: 0.75rem 0 1rem; border-color: #e9ecef; }
.close-button-custom {
   position: absolute; top: 0.75rem; right: 1rem;
   font-size: 1.8rem; font-weight: bold; line-height: 1;
   color: #adb5bd; background: none; border: none; cursor: pointer;
}
.close-button-custom:hover { color: #435666; }
.modal-body-custom { font-size: 14px; color: #435666; }
.modal-footer-custom { margin-top: 1.25rem; display: flex; justify-content: flex-end; gap: 8px; }
.btn-modal-cancel { background: #e9ecef; border: none; border-radius: 8px; color: #435666; }
.btn-modal-cancel:hover { background: #dee2e6; color: #212529; }

/* Section grouping */
.settings-section {
   margin-bottom: 1.5rem;
   padding-bottom: 1.5rem;
   border-bottom: 1px solid #e9ecef;
}

.settings-section:last-child {
   border-bottom: none;
   margin-bottom: 0;
}

.section-title {
   color: #435666;
   font-weight: 700;
   font-size: 15px;
   text-transform: uppercase;
   letter-spacing: 0.5px;
   margin-bottom: 1rem;
   padding-bottom: 0.5rem;
}

/* Setting rows */
.setting-row {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 12px 16px;
   margin-bottom: 4px;
   border-radius: 8px;
   transition: background-color 0.15s ease;
}

.setting-row:hover {
   background-color: #f8f9fa;
}

.setting-info {
   display: flex;
   flex-direction: column;
   flex: 1;
   margin-right: 1rem;
}

.setting-label {
   font-weight: 600;
   font-size: 14px;
   color: #2c3e50;
}

.setting-desc {
   font-size: 13px;
   color: #6c757d;
   margin-top: 2px;
}

/* Toggle switches */
.form-check-input:checked {
   background-color: rgba(25, 135, 84, 1.0);
   border-color: rgba(25, 135, 84, 1.0);
}

.form-custom-check-input {
   opacity: 0.7;
   width: 5em !important;
}

.form-custom-check-size {
   min-height: calc(0.8em + 1rem + 1.5px);
   padding: 0.5rem 1rem;
   font-size: 0.8em;
   border-radius: 1rem;
}

/* Button groups */
.btn-check-left { min-width: 5rem; }
.btn-check-center { min-width: 3.5rem; }
.btn-check-right { min-width: 5rem; }

.btn-outline-right { color: #191919; background-color: transparent; border-color: grey }
.btn-outline-right:hover, .btn-outline-right.active, .btn-outline-right:active { color: whitesmoke; background-color: #191919; border-color: #191919; font-weight: bold; }

.btn-outline-center { color: #a3c0d1; background-color: transparent; border-color: grey }
.btn-outline-center:hover, .btn-outline-center.active, .btn-outline-center:active { color: whitesmoke; background-color: #B2B2B2; border-color: #B2B2B2; font-weight: bold; }

.btn-outline-left { color: rgba(25, 135, 84, 1.0); background-color: transparent; border-color: grey }
.btn-outline-left:hover, .btn-outline-left.active, .btn-outline-left:active { color: whitesmoke; background-color: rgba(25, 135, 84, 1.0); border-color: rgba(25, 135, 84, 1.0); font-weight: bold; }

.hand-cursor {
   cursor: pointer;
}

.table {
   font-size: 14px;
}
</style>